<!-- Background Parallax -->
<img fxHide.xs appParallax [ratio]="1.5" class="background-circular" src="/assets/img/background-circular.svg"
    alt="Background Circular" />
<img fxHide fxShow.xs appParallax [ratio]="0.5" class="background-circular"
    src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />

<app-navbar></app-navbar>
<app-breadcrumb></app-breadcrumb>

<div class="cart-container" fxLayoutAlign="center start">
    <!-- Cart Empty -->
    <div *ngIf="!isLoading && cart.length == 0" class="cart-empty" fxLayout="column" fxFlex="500px" fxFlex.xs="90%">
        <i data-feather="shopping-cart" class="empty-icon"></i>
        <h2>Tu carrito está vacío</h2>
        <p>¡Descubrí increíbles productos y empezá a llenar tu carrito!</p>
        <button mat-raised-button color="primary" [routerLink]="['/']">
            <i data-feather="search"></i>
            Explorar productos
        </button>
    </div>

    <!-- Cart with Products -->
    <div *ngIf="isLoading || cart.length > 0" fxLayout="row" fxLayout.lt-md="column" fxFlex="1100px" fxFlex.xs="95%" fxFlex.sm="90%"
        fxFlex.md="95%" fxLayoutGap="24px" fxLayoutGap.xs="16px">
        
        <!-- Products Section -->
        <div fxFlex="65%" fxFlex.md="62%" fxFlexOrder.lt-md="2" class="cart-main">
            <!-- Header -->
            <div class="cart-header">
                <div class="header-content">
                    <div class="icon-wrapper">
                        <i data-feather="shopping-cart"></i>
                    </div>
                    <h1>Carrito de Compras</h1>
                </div>
                <span class="item-count" *ngIf="cart.length > 0">{{ cart.length }} {{ cart.length === 1 ? 'producto' : 'productos' }}</span>
            </div>

            <!-- Loading State -->
            <div class="cart-loading" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
                <p>Cargando tu carrito...</p>
            </div>

            <!-- Product List -->
            <div class="cart-products" *ngIf="!isLoading && cart.length > 0">
                <div class="product-card" *ngFor="let item of cart; let i = index" id="product-{{i}}">
                    <div class="product-main-info">
                        <div class="product-image" [routerLink]="['/producto/' + item.product_id + '/' + processProductTitle(item.product)]">
                            <img *ngIf="item.product.photo_feature == '' || item.product.photo_feature == undefined" 
                                 src="/assets/img/products/product-04.webp" [alt]="item.product.title" />
                            <img *ngIf="item.product.photo_feature != '' && item.product.photo_feature != undefined" 
                                 [src]="item.product.photo_feature" [alt]="item.product.title" />
                        </div>
                        
                        <div class="product-details">
                            <a class="product-title" [routerLink]="['/producto/' + item.product.id + '/' + processProductTitle(item.product)]">
                                {{ item.product.title }}
                            </a>
                            
                            <div class="product-meta">
                                <div class="quantity-section">
                                    <span class="quantity-text">{{ item.quantity }} x</span>
                                    <span class="unit-price">{{ getPrice(item.product) | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                                </div>
                                <div class="discount-section" *ngIf="getDiscount(item.product) != ''">
                                    <span class="original-price">{{ getPriceWithoutDiscount(item.product) | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                                    <span class="discount-badge">{{ getDiscount(item.product) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="product-controls">
                        <div class="quantity-wrapper">
                            <button mat-icon-button (click)="minQuantity(item)" [disabled]="!minEnabled || item.quantity <= 1" class="btn-qty">
                                <i data-feather="minus"></i>
                            </button>
                            <span class="qty-value">{{ item.quantity }}</span>
                            <button mat-icon-button (click)="sumQuantity(item)" [disabled]="getStock(item.product) <= item.quantity" class="btn-qty">
                                <i data-feather="plus"></i>
                            </button>
                        </div>
                        
                        <div class="item-subtotal">
                            <span class="subtotal-value">{{ getPrice(item.product) * item.quantity | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                        </div>
                        
                        <button mat-icon-button (click)="removeItem(item)" class="btn-delete" matTooltip="Eliminar">
                            <i data-feather="trash-2"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Info Sections -->
            <div class="info-sections" *ngIf="!isLoading && cart.length > 0">
                <div class="info-card payment-methods">
                    <div class="info-header">
                        <i data-feather="credit-card"></i>
                        <h3>Tarjetas aceptadas</h3>
                    </div>
                    <div class="payment-cards">
                        <img src="/assets/img/credit-cards/Maestro.png" alt="Maestro" />
                        <img src="/assets/img/credit-cards/cabal.png" alt="Cabal" />
                        <img src="/assets/img/credit-cards/Visa.png" alt="Visa" />
                        <img src="/assets/img/credit-cards/Mastercard.png" alt="MasterCard" />
                        <img src="/assets/img/credit-cards/mutual-card.png" alt="Mutual Card" />
                    </div>
                </div>

                <div class="info-card shipping-info">
                    <div class="info-header">
                        <i data-feather="truck"></i>
                        <h3>Envío seguro</h3>
                    </div>
                    <p>Recibí tu producto con envío rápido y seguro. Lo preparamos y despachamos desde nuestro centro de almacenamiento.</p>
                </div>
            </div>
        </div>

        <!-- Summary Sidebar -->
        <div *ngIf="!isLoading && cart.length > 0" class="cart-summary" fxFlex="35%" fxFlex.md="38%" fxFlexOrder.lt-md="1">
            <div class="summary-header">
                <div class="icon-wrapper">
                    <i data-feather="file-text"></i>
                </div>
                <h2>Resumen del pedido</h2>
            </div>

            <div class="summary-content">
                <div class="summary-item">
                    <span class="label">Subtotal</span>
                    <span class="value">{{ cartSubtotal | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                </div>
                
                <div class="summary-item">
                    <span class="label">Cargos adicionales</span>
                    <span class="value">{{ cartAdditional | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                </div>
                
                <div class="summary-item " *ngIf="cartDiscount > 0">
                    <span class="label">
                        Descuentos en productos
                    </span>
                    <span class="value discount">- {{ cartDiscount | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                </div>
                
                <div class="summary-divider"></div>
                
                <div class="summary-total">
                    <span class="total-label">Total</span>
                    <span class="total-value">{{ cartTotal | currency:'ARS':'symbol-narrow':'.2-2':'es-AR' }}</span>
                </div>
                
                <button mat-raised-button class="btn-checkout" (click)="onClickBuy()">
                    <i data-feather="shopping-bag"></i>
                    <span>Continuar compra</span>
                </button>

            </div>
        </div>
    </div>
</div>

<div class="faqs">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1100px" fxFlex.lt-lg="95%" fxFlex.xs="95%">
            <app-faqs-questions></app-faqs-questions>
        </div>
    </div>
</div>

<app-footer></app-footer>
